<template>
    <div id="profile" class="tw-pr-2 tw-flex-col tw-mt-5">
        <subscribe-popup :artist="artist" :pageOptions="pageOptions" :options="options" :spotifyArtist="spotifyArtist" v-if="options.subscriber && !subscriber"></subscribe-popup>
        <v-card class="tw-rounded-2xl tw-shadow-none tw-rounded-b-none tw-overflow-visible">
            <v-img height="160" class="tw-rounded-2xl tw-rounded-b-none" :src="options ? options.cover_img : artist.post_image.length ? artist.post_image : spotifyArtist.images[2].url"></v-img>
            <v-avatar size="132" class="tw-absolute tw-left-0 tw-right-0 tw-mr-auto tw-ml-auto avatar tw-rounded-full">
                <img alt="user" class="tw-border tw-border-solid tw-border-white tw-border-opacity-10" :src="pageOptions.logo ? pageOptions.logo : (artist.post_image ? artist.post_image : spotifyArtist.images[2].url)">
            </v-avatar>
        </v-card>
        <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-mt-10">
            <div class="tw-w-full tw-truncate tw-mx-auto tw-text-center">
                <h3 class="tw-font-sans tw-text-white tw-text-lg tw-font-bold tw-p-0 tw-m-0 tw-mt-10 tw-mb-3 tw-truncate">{{artist.artista_nome}}</h3>
                <v-btn v-if="options.subscriber && !subscriber" class="waves-effect tw-rounded-full tw-px-5 tw-py-2 tw-from-purple-400 tw-to-purple-600 tw-bg-gradient-to-b tw-text-white tw-font-sans tw-text-xs tw-font-bold tw-uppercase tw-tracking-wide tw-leading-none subscribeActivator"><i class="fas fa-key tw-mr-1"></i><span class="tw-leading-none">Assinar</span></v-btn>
                <v-btn v-if="options.subscriber && subscriber" class="waves-effect tw-rounded-full tw-px-5 tw-py-2 tw-from-purple-400 tw-to-purple-600 tw-bg-gradient-to-b tw-text-white tw-font-sans tw-text-xs tw-font-bold tw-uppercase tw-tracking-wide tw-leading-none"><i class="fas fa-key tw-mr-1"></i><span class="tw-leading-none">Assinando</span></v-btn>
            </div>
            <div class="tw-text-left tw-text-sm tw-font-sans tw-text-white tw-mt-8 tw-w-full">
                <h4 class="tw-font-sans tw-text-xs tw-font-medium tw-uppercase">{{options ? (options.label ? options.label : 'Backstage') : 'Backstage'}}</h4>
                <p class="tw-opacity-40 tw-whitespace-pre-line tw--mt-3">
                    {{options ? (options.description ? options.description : 'Bem vindo ao meu Backstage. Aqui você tem acesso a conteúdos, promoções e vantagens exclusivas para os seguidores mais engajados. Siga, assine e tenha acesso Vip.') : 'Bem vindo ao meu Backstage. Aqui você tem acesso a conteúdos, promoções e vantagens exclusivas para os seguidores mais engajados. Siga, assine e tenha acesso Vip.'}}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '@/eventbus';
import {mapState, mapActions} from 'vuex';
import SubscribePopup from './subscribe-popup';
export default {
    props: ['artist', 'pageOptions', 'options', 'spotifyArtist', 'shareLinks', 'subscriber'],
    components: {SubscribePopup},
    computed: {
        ...mapState('followstatus', ['following']),
    },
    methods:{
        ...mapActions('followstatus', ['follow', 'checkStatus']),
    },
}
</script>

<style>
.avatar{
    bottom: -40%;
}
</style>